import { render } from "./SupervisedEntitiesList.vue?vue&type=template&id=dc6930c2"
import script from "./SupervisedEntitiesList.vue?vue&type=script&lang=js"
export * from "./SupervisedEntitiesList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\FinanssivalvontaCMS12\\Finanssivalvonta.web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__